import Image from 'next/image';
import { useRouter } from 'next/router';
import styled from 'styled-components';

import { ArticleMeta } from './ArticleMeta';

const StyledLandscapeArticleCard = styled.div`
  min-height: 200px;
  width: 100%;
  max-width: 500px;
  overflow: hidden;
  border-radius: 15px;
  // background-color: rgba(0, 0, 0, 0.5);
  // background: url("images/banner-desk-tab.jpg");
  position: relative;
  display: flex;
  align-items: flex-end;
  cursor: pointer;

  @media screen and (min-width: 768px) {
    min-height: 280px;
    width: 100%;
    max-width: 600px;
  }

  .article-cover-image {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;

    .img {
      object-fit: cover;
      width: 100%;
      position: absolute;
    }

    &:: after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 2;
      background: linear-gradient(45deg, rgba(0, 0, 0, 0.5) 70%, rgba(0, 0, 0, 0));
    }
  }

  .article-card-details {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    height: 100%;
    position: sticky;
    z-index: 2;
    padding: 1em 1em;

    .article-title,
    span {
      color: white;
    }

    .article-title {
      font-weight: 600;
    }

    span {
      font-size: 1.3rem;
    }

    .detail:not(:last-child) {
      margin-right: 1em;
      padding-right: 1em;
      border-right: 1px solid ${({ theme }) => theme.primaryLink};
    }
  }
`;

export const LandscapeArticleCard = ({ article }) => {
  const router = useRouter();

  const handleClick = (slug) => {
    router.push(`/blog/${slug?.current}`);
  };

  return (
    <StyledLandscapeArticleCard
      className="landscape-article-card"
      onClick={() => handleClick(article.slug)}>
      <div className="article-cover-image">
        <Image
          alt={article?.title}
          src={article.coverImage?.asset?.url}
          layout="fill"
          className="img"
        />
      </div>
      <div className="article-card-details">
        <h2 className="article-title">{article.title}</h2>

        <div>
          <ArticleMeta author={article.author} date={article._updatedAt} />
        </div>
      </div>
    </StyledLandscapeArticleCard>
  );
};
